export default "__VITE_PUBLIC_ASSET__8ef522aa__"